<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          <CIcon name="cil-vertical-align-bottom" />
          <h5 class="d-inline ml-2">Menu Scraper</h5>
        </CCardHeader>

        <CCardBody>
          <Scraper />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Scraper from "./Scraper";

export default {
  name: "MenuScraper",
  components: {
    Scraper,
  }
};
</script>
